import { type QueryClient } from '@tanstack/react-query';

import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type IGetOffersByPinResponse } from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

import { type QueryKey, getQueryKey } from './internal/config';

export class FetchGetOffersByPinLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public getQueryData(queryKeyParameters: QueryKey[1]): IGetOffersByPinResponse | null {
    return extractUndefined(this.queryClient.getQueryData<IGetOffersByPinResponse>(getQueryKey(queryKeyParameters)));
  }

  public setQueryData(
    updater: IGetOffersByPinResponse,
    queryKeyParameters: QueryKey[1],
  ): IGetOffersByPinResponse | null {
    return extractUndefined(
      this.queryClient.setQueryData<IGetOffersByPinResponse>(getQueryKey(queryKeyParameters), updater),
    );
  }
}
